import { Confirm } from "features/無料占いBot/components/Confirm";
import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";

interface Props {
  name: string;
  text?: string;
  icon?: string;
  confirm?: boolean;
  onClickConfirm?: () => void;
}

export const Confirmable: FC<Props> = ({
  name,
  text,
  icon,
  confirm = false,
  onClickConfirm,
  children,
}) => {
  const { control } = useFormContext();
  const value = useWatch({ name, control });

  return (
    <>
      {children}
      {(value || confirm) && (
        <Confirm
          name={`${name}Confirm`}
          text={text}
          icon={icon}
          onClickConfirm={onClickConfirm}
        />
      )}
    </>
  );
};
